<template>
  <b-modal
    id="create-floor-modal"
    title="Floor Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Floor Create</h2>
    </template>
    <b-form @submit.prevent enctype="multipart/form-data">
      <b-form-group label-for="floor_no">
        <template #label>
          Floor No <span class="text-danger">*</span>
        </template>
        <b-input
          id="floor_no"
          v-model="floor_no"
          placeholder="Floor No"
          v-restrict="regex"
          required
        ></b-input>
      </b-form-group>
      <b-form-group label-for="sequence">
        <template #label>
          Floor Sequence <span class="text-danger">*</span>
        </template>
        <b-input
          id="sequence"
          v-model="sequence"
          placeholder="Floor Sequence"          
          required
          type="number"
        ></b-input>
      </b-form-group>

      <b-form-group class="mt-2 text-right">
        <b-button
          type="submit"
          variant="primary"
          pill
          class="mr-1"
          @click="submit"
        >
          Add Floor
        </b-button>
        <b-button
          type="reset"
          variant="outline-secondary"
          @click="reset"
          pill
        >
          Reset
        </b-button>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: { building : Object },
  mixins: [util],
  data() {
    return {
      required,
      floor_no: "",
      sequence: null,
      regex: /^[a-zA-Z ]*$/,
    };
  },
  methods: {
    ...mapActions({
      createFloor: "appData/createFloor",
    }),

    async submit() {
      try {
        const formData = new FormData();
        formData.append("building", this.building.id);
        formData.append("floor_no", this.floor_no);
        formData.append("sequence", this.sequence);
        formData.append("created_by", this.getLoggedInUser.id);
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.createFloor(formData);
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Floor Added Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("create-floor-modal");
          });          
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },
       
    reset() {
      this.floor_no = "";
      this.sequence = null;
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),    
  },  
 
};
</script>

<style></style>
